import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import "./styles/global.css";
import "./styles/platform.css";
import "./styles/command-tokens.css";
import { initNative } from './native';
import { initSentry } from './monitoring';
import ErrorBoundary from './shared/ErrorBoundary';

/* Crash reporting (no-op unless REACT_APP_SENTRY_DSN is set at build time) */
initSentry();

/* Boot native plugins (no-op on web) */
initNative();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <ErrorBoundary name="root">
    <App />
  </ErrorBoundary>
);
